import type { Activity } from '../types/domain';
export type MissionOptions={subject?:string|null;interest?:string|null;recentQuestions?:string[]};
type SavedMission={createdAt:number;activities:Activity[]};
const pending=new Map<string,Promise<{activities:Activity[]}>>();
const TTL=24*60*60*1000;
function key(accountId:string,learnerId:string,opts:MissionOptions){return `mlw-mission-v1:${accountId}:${learnerId}:${JSON.stringify([opts.subject||'',opts.interest||''])}`}
function read(k:string):SavedMission|null{try{const value=JSON.parse(localStorage.getItem(k)||'null');if(value&&Date.now()-value.createdAt<TTL&&Array.isArray(value.activities)&&value.activities.length===3)return value;}catch{}return null}
export function clearSavedMission(accountId:string,learnerId:string,opts:MissionOptions){try{localStorage.removeItem(key(accountId,learnerId,opts))}catch{}}
export function getOrCreateMission(accountId:string,learnerId:string,opts:MissionOptions,generate:()=>Promise<{activities:Activity[]}>){
  const k=key(accountId,learnerId,opts);
  const existing=pending.get(k);if(existing)return existing;
  async function load(){
    const saved=read(k);if(saved)return {activities:saved.activities};
    const result=await generate();
    if(!Array.isArray(result.activities)||result.activities.length!==3)throw new Error('Your fresh mission could not be prepared. Please try again.');
    try{localStorage.setItem(k,JSON.stringify({createdAt:Date.now(),activities:result.activities}));}catch{}
    return result;
  }
  // Web Locks serialize generation across tabs; the in-memory promise covers React remounts.
  const request:Promise<{activities:Activity[]}>=(async()=>{
    if(typeof navigator!=='undefined'&&navigator.locks)return await navigator.locks.request(k,load);
    return await load();
  })();
  pending.set(k,request);
  void request.finally(()=>pending.delete(k)).catch(()=>{});
  return request;
}
